import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: HomeView,
     redirect: " ",
    children: [
      {
        path: " ",
        name: "homePage",
        component: () => import("../views/homePage.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
        },
      },
      {
        path: "Products",
        name: "products",
        component: () => import("../views/products.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "产品",
        },
      },
      {
        path: "Pricing",
        name: "pricing",
        component: () => import("../views/pricing.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "定价",
        },
      },
      {
        path: "Solution",
        name: "solution",
        component: () => import("../views/solution.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "解决方案",
        },
      },
      {
        path: "News",
        name: "news",
        component: () => import("../views/news.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "最新动态",
        },
      },
      {
        path: "Resources",
        name: "resources",
        component: () => import("../views/resources.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "资源与支持",
        },
      },
      {
        path: "Contact",
        name: "contact",
        component: () => import("../views/contact.vue"),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: "联系我们",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: '/aiotec/web',
  routes,
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
router.afterEach(() => {
  window.scrollTo(0, 0); // 滚动到顶部
});
export default router;
